const FOCUSABLE = 'a, button, input, select, textarea';

function disableFocusIn(container) {
    // Light DOM focusables
    container.querySelectorAll(FOCUSABLE).forEach(el => el.setAttribute('tabindex', '-1'));
    // querySelectorAll can't pierce shadow DOM; inert on the shadow host blocks shadow DOM focusables.
    // (e.g. <shopify-payment-terms> renders a <button> in declarative shadow DOM)
    if (container.shadowRoot) container.setAttribute('inert', '');
    container.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) el.setAttribute('inert', '');
    });
}

function restoreFocusIn(container) {
    container.querySelectorAll('[tabindex="-1"]').forEach(el => {
        if (!el.closest('[aria-hidden="true"]')) el.removeAttribute('tabindex');
    });
    container.querySelectorAll('[inert]').forEach(el => {
        if (!el.closest('[aria-hidden="true"]')) el.removeAttribute('inert');
    });
}

function hideAriaHiddenFocusables() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(disableFocusIn);
}

// Immediate pass: static elements already in HTML (pswp dialog, Flickity cells, etc.)
hideAriaHiddenFocusables();

// Post-init pass: slideActions() runs inside DOMContentLoaded → load('*') and may re-enable
// tabindex on elements inside aria-hidden tab containers. theme.js registers its listener
// before accessibility.js, so ours runs after slideActions() completes.
document.addEventListener('DOMContentLoaded', hideAriaHiddenFocusables);

new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const el = mutation.target;
            if (el.getAttribute('aria-hidden') === 'true') {
                disableFocusIn(el);
            } else {
                // Flickity uses removeAttribute('aria-hidden') — restore only elements not
                // still inside another aria-hidden container (e.g. non-selected Flickity cells
                // inside a tab that just became active).
                restoreFocusIn(el);
            }
        }

        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                // GridSwatch inserts swatch <a> links asynchronously after fetchProduct() resolves
                if (node.closest('[aria-hidden="true"]')) {
                    if (node.matches(FOCUSABLE)) node.setAttribute('tabindex', '-1');
                    disableFocusIn(node);
                }
            });
        }

        // Guard: prevent slideActions() or other code from re-enabling tabindex on elements
        // that are inside an aria-hidden container.
        if (mutation.type === 'attributes' && mutation.attributeName === 'tabindex') {
            const el = mutation.target;
            if (el.getAttribute('tabindex') !== '-1' && el.closest('[aria-hidden="true"]')) {
                el.setAttribute('tabindex', '-1');
            }
        }
    });
}).observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'tabindex'],
    childList: true,
    subtree: true,
});
